import React from 'react'
import './new_dashboard_home.css'
import { getImgSrc } from "../../../../helpers/getImgSrc"
import { GoPeople } from "react-icons/go";
import DashboardSocialMediaMetricsCard from '../../../../components/client/dashboard/new_dashboard/DashboardSocialMediaMetricsCard';


const NewDashboardHome = ({
    total,
    paid_social,
    paid_social_facebook,
    paid_social_snapchat,
    paid_social_instagram,
    paid_social_linkedin,
    organic_social_data,
    paid_media,
    owned_media
},

) => {
    let date = new Date()
   

    const headerDashboardDataCards = [
        {
            heading: 'Total Accounts Connected',
            value: total?.total_accounts_connected ?? 0,
            value_desc: 'All platforms',
            logo_background_color: '#efebf8',
            logo_name: 'users_active'
        },
        {
            heading: 'Total Ads Connected',
            value:total?.total_ads_connected ?? 0,
            value_desc: 'Across all platforms',
            logo_background_color: '#fce7f3',
            logo_name: 'reports'
        },
        {
            // heading: 'Total Posts Connected',
            heading:'Total Organic Posts Connected',
            value: total?.total_posts_connected ?? 0,
            value_desc: 'Organic posts across all platforms',
            logo_background_color: '#dbeafe',
            logo_name: 'reports'
        },
        {
            heading: 'Total URLs Connected',
            value: total?.total_urls_connected ?? 0,
            value_desc: 'For google analytics',
            logo_background_color: '#dcfce7',
            logo_name: 'reports'
        }
    ]

    const socialMediaData = [
        {
            name: 'Paid Social Media',
            logo_name: 'reports',
            logo_background_color: '#f3e8ff',
            background_color: '#f9f2ff',
            subheading: `Facebook, Instagram & LinkedIn - ${paid_social?.campaigns_count} Total Campaigns`,
            total_metrics: [
                {
                    name: 'total spend   (Facebook, Instagram & LinkedIn)',
                    value: `$ ${paid_social?.spend}`
                },
                {
                    name: 'total clicks   (Facebook, Instagram & LinkedIn)',
                    value:paid_social?.clicks
                },
                {
                    name: 'total impressions   (Facebook, Instagram & LinkedIn)',
                    value: paid_social?.impressions
                }
            ],
            platform_metrics: [
                {
                    platform_name: 'facebook',
                    platform_icon: 'facebook',
                    impressions: paid_social_facebook?.impressions,
                    // reactions: 345,
                    clicks:  paid_social_facebook?.clicks,
                    spend: paid_social_facebook?.spend
                },
                {
                    platform_name: 'instagram',
                    platform_icon: 'instagram',
                    impressions: paid_social_instagram?.impressions,
                    clicks:  paid_social_instagram?.clicks,
                    spend: paid_social_instagram?.spend,
               
                    
                },
                {
                    platform_name: 'linkedin',
                    platform_icon: 'linkedin',
                    impressions: paid_social_linkedin?.impressions,
                    clicks:  paid_social_linkedin?.clicks,
                    spend: paid_social_linkedin?.spend
                }
            ]


        },
        {
            name: 'Organic Social',
            logo_name: 'reports',
            logo_background_color: '#dbeafe',
            background_color: '#ebf4ff',
            subheading: `Facebook, Instagram, LinkedIn - ${organic_social_data?.total_posts} Total Posts`,
            total_metrics: [
                {
                    name: 'total Share',
                    value:organic_social_data?.total_shares
                },
                {
                    name: 'total clicks',
                    value: organic_social_data?.total_clicks
                },
                {
                    name: 'total impressions',
                    value: organic_social_data?.total_impressions
                }
            ],
            platform_metrics: [
                {
                    platform_name: 'facebook',
                    platform_icon: 'facebook',
                    impressions:organic_social_data?.facebook_posts?.impressions ,
                    reactions: 0,
                    clicks: organic_social_data?.facebook_posts?.clicks,
                    shares:organic_social_data?.facebook_posts?.shares
                },
                {
                    platform_name: 'instagram',
                    platform_icon: 'instagram',
                    // impressions:organic_social_data?.instagram_posts?.impressions ,
                    // reactions: 0,
                    // clicks: organic_social_data?.instagram_posts?.clicks,
                    reach:organic_social_data?.instagram_posts?.reach,
                    shares:organic_social_data?.instagram_posts?.shares,
                    likes:organic_social_data?.instagram_posts?.likes
                },
                {
                    platform_name: 'linkedin',
                    platform_icon: 'linkedin',
                    impressions:organic_social_data?.linkedin_posts?.impressions ,
                    reactions: 0,
                    clicks: organic_social_data?.linkedin_posts?.clicks,
                    shares:organic_social_data?.linkedin_posts?.shares
                },
                {
                    platform_name: organic_social_data?.most_productive_platform?.platform_name,
                    platform_icon:organic_social_data?.most_productive_platform?.platform_name,
                    productive_platform_name: organic_social_data?.most_productive_platform?.platform_name,
                    productive_platform_icon: organic_social_data?.most_productive_platform?.platform_name,
                    percentage: Math.floor(organic_social_data?.most_productive_platform?.click_percentage)

                }
            ]


        },
        {
            name: 'Platform Performance',
            logo_name: 'reports',
            logo_background_color: '#e0e7ff',
            background_color: '#ebefff',
            subheading: '',
            graph_data: [
                {
                    name: 'Paid Social (engagement rate)',
                    labels: ['Paid Social (engagement rate)'],
                    data: [
                        {
                            label: 'Facebook',
                            backgroundColor: '#D3A4FF',
                            borderColor: '#D3A4FF',
                            borderWidth: 1,
                            data: [
                                
                                (paid_social_facebook?.impressions>0?((paid_social_facebook?.clicks)/paid_social_facebook?.impressions)*100:0)


                            ] // Leads data
                        },
                        {
                            label: 'Instagram',
                            backgroundColor: '#FFB1E0', // Green bars
                            borderColor: '#FFB1E0',
                            borderWidth: 1,
                            data: [
                                (paid_social_instagram?.impressions>0?((paid_social_instagram?.clicks)/paid_social_instagram?.impressions)*100:0)
                            ] // Spent data
                        },

                        {
                            label: 'LinkedIn',
                            backgroundColor: '#FFE58A', // Red bars
                            borderColor: '#FFE58A',
                            borderWidth: 1,
                            data: [
                                (paid_social_linkedin?.impressions>0?((paid_social_linkedin?.clicks)/paid_social_linkedin?.impressions)*100:0)
                            ]
                        }
                    ]
                },
                {
                    name: 'Organic Social (engagement rate)',
                    labels: ['Organic Social (engagement rate)'],
                    data: [
                        {
                            label: 'Facebook',
                            backgroundColor: '#D3A4FF',
                            borderColor: '#D3A4FF',
                            borderWidth: 1,
                            data: [((organic_social_data?.facebook_posts?.clicks+organic_social_data?.facebook_posts?.shares)/organic_social_data?.facebook_posts?.impressions)*100] // Leads data
                        },
                        {
                            label: 'Instagram',
                            backgroundColor: '#FFB1E0', // Green bars
                            borderColor: '#FFB1E0',
                            borderWidth: 1,
                            data: [((organic_social_data?.instagram_posts?.clicks+organic_social_data?.instagram_posts?.shares)/organic_social_data?.instagram_posts?.impressions)*100]
                        },

                        {
                            label: 'LinkedIn',
                            backgroundColor: '#FFE58A', // Red bars
                            borderColor: '#FFE58A',
                            borderWidth: 1,
                            data: [((organic_social_data?.linkedin_posts?.clicks+organic_social_data?.linkedin_posts?.shares)/organic_social_data?.linkedin_posts?.impressions)*100]
                        }
                    ]
                }
            ]




        },
        {
            name: 'Google Ads',
            logo_name: 'reports',
            logo_background_color: '#fce7f3',
            background_color: '#fcf0f7',
            subheading: paid_media?.campaigns_count+' Total Campaigns',
            total_metrics: [
                {
                    name: 'total cost',
                    value: '$'+paid_media?.spend
                },
                {
                    name: 'impressions',
                    value: paid_media?.impressions
                },
                {
                    name: 'clicks',
                    value: paid_media?.clicks
                },
                {
                    name: 'conversions',
                    value: 0
                }
            ],



        },
        {
            name: 'Google Analytics',
            logo_name: 'reports',
            logo_background_color: '#dcfce7',
            background_color: '#ebfcf1',
            subheading: '',
            total_metrics: [
                {
                    name: 'users',
                    value: owned_media?.metrics?.total_users
                },
                {
                    name: 'sessions',
                    value: owned_media?.metrics?.sessions
                },
                {
                    name: 'page views',
                    value:  owned_media?.metrics?.screen_page_views
                },
                {
                    name: 'avg. session duration',
                    value: owned_media?.metrics?.avg_session_duration?.toFixed(2) +" S"
                }
            ],



        }

    ]




    return (
        <div className='dashboard_container'>
            <section className='dashboard_header_section' id="overview-section">
                <div className="header_overview_metrics_wrapper">

                    <div className="header_overview_metrics_wrapper_top">
                        <div className='header_overview_metrics_wrapper_top_heading' >
                            <div className='header_overview_metrics_wrapper_top_logo' >
                                <img src={getImgSrc('reports')} alt="" />
                            </div>
                            <div className='header_overview_metrics_wrapper_top_heading_text'>
                                <h3 className=''>Overview</h3>
                                <span></span>
                            </div>


                        </div>


                    </div>

                    <div className="header_overview_metrics_wrapper_bottom">
                        {headerDashboardDataCards?.map((data,index) => {
                            return <div key={index} className="header_overview_metrics_card">
                                <div className='header_overview_metrics_card_top'>
                                    <h5 className='overview_metrics_card_heading'>{data?.heading}</h5>
                                    <div className='rounded rounded-circle' style={{ backgroundColor: data?.logo_background_color }}>
                                        <img src={getImgSrc(data?.logo_name)} alt="" height={20} className='m-2' />
                                    </div>
                                </div>
                                <div className='header_overview_metrics_card_bottom'>
                                    <h3>{data?.value}</h3>
                                    <span>{data?.value_desc}</span>
                                </div>

                            </div>
                        })}

                    </div>
                </div>



            </section>
            <section className="paid_social_media_container" >
                {/* <div className="paid_social_media_card">
                    <div className="paid_social_media_card_top">
                        <div className='paid_social_media_card_top_heading' >
                            <div className='paid_social_media_card_top_heading_logo'>
                                <img src={getImgSrc('reports')} alt="" />
                            </div>
                            <div className='paid_social_media_card_top_heading_text'>
                                <h3 className=''>Paid Social Media</h3>
                                <span>Facebook ,Instagram,LinkedIn - 3 Total Campaigns</span>
                            </div>


                        </div>


                    </div>

                    <div className="paid_social_media_card_bottom">
                        <div className='total_social_media_metrics_container'>
                            <div className='total_social_media_metrics_card'>
                                 <span>total spend</span>
                                 <h3>$125</h3>
                            </div>
                            <div className='total_social_media_metrics_card'>
                                 <span>total clicks</span>
                                 <h3>1247</h3>
                            </div>
                            <div className='total_social_media_metrics_card'>
                                 <span>total impressions</span>
                                 <h3>45680</h3>
                            </div>

                        </div>
                 
                        <div className="paid_social_media_metrics_card_container">
                            <div className='paid_social_media_metrics_card'>
                                <div className="paid_social_media_metrics_card_top">
                                    <div className='paid_social_media_metrics_card_top_header'>
                                        <div className='paid_social_media_metrics_card_top_header_logo'>
                                            <img src={getImgSrc('facebook')} alt="" />
                                        </div>
                                         <h5>Facebook</h5>

                                    </div>
                                </div>
                                <div className="paid_social_media_metrics_card_bottom">
                                    <div className='records_container'>
                                        <div className='record'>
                                            <span>Impressions</span>
                                            <span>8745</span>

                                        </div>
                                        <div className='record'>
                                            <span>Reactions</span>
                                            <span>342</span>

                                        </div>
                                        <div className='record'>
                                            <span>Clicks</span>
                                            <span>156</span>

                                        </div>

                                    </div>

                                </div>


                            </div>
                        
                            <div className='paid_social_media_metrics_card'>
                                <div className="paid_social_media_metrics_card_top paid_social_instagram">
                                    <div className='paid_social_media_metrics_card_top_header'>
                                        <div className='paid_social_media_metrics_card_top_header_logo'>
                                            <img src={getImgSrc('instagram')} alt="" />
                                        </div>
                                         <h5>Instagram</h5>

                                    </div>
                                </div>
                                <div className="paid_social_media_metrics_card_bottom">
                                    <div className='records_container'>
                                        <div className='record'>
                                            <span>Impressions</span>
                                            <span>8745</span>

                                        </div>
                                        <div className='record'>
                                            <span>Reactions</span>
                                            <span>342</span>

                                        </div>
                                        <div className='record'>
                                            <span>Clicks</span>
                                            <span>156</span>

                                        </div>

                                    </div>

                                </div>


                            </div>
                         
                            <div className='paid_social_media_metrics_card'>
                                <div className="paid_social_media_metrics_card_top">
                                    <div className='paid_social_media_metrics_card_top_header'>
                                        <div className='paid_social_media_metrics_card_top_header_logo'>
                                            <img src={getImgSrc('linkedin')} alt="" />
                                        </div>
                                         <h5>LinkedIn</h5>

                                    </div>
                                </div>
                                <div className="paid_social_media_metrics_card_bottom">
                                    <div className='records_container'>
                                        <div className='record'>
                                            <span>Impressions</span>
                                            <span>8745</span>

                                        </div>
                                        <div className='record'>
                                            <span>Reactions</span>
                                            <span>342</span>

                                        </div>
                                        <div className='record'>
                                            <span>Clicks</span>
                                            <span>156</span>

                                        </div>

                                    </div>

                                </div>


                            </div>


                        </div>
                    
                     
                   



                    </div>

                </div> */}
                {socialMediaData?.map((metrics_data,index) => {

                    return  <DashboardSocialMediaMetricsCard key={index}  metrics_data={metrics_data} />
                })}




            </section>


        </div>
    )
}

export default NewDashboardHome